import request from '@/utils/request'; // 获取列表

export function getData(data) {
  return request({
    url: '/ecargoaccount/sysAppli/userPageInfo',
    method: 'post',
    data: data
  });
}
export function updateStatus(data) {
  return request({
    url: '/ecargoaccount/sysAppli/updateStatus',
    method: 'post',
    data: data
  });
}
export function userInfo(data) {
  return request({
    url: '/ecargoaccount/sysAppli/userInfo',
    method: 'get',
    params: data
  });
}